import React from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Toolbar,
  Typography,
  Divider,
  Link,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CampaignIcon from '@mui/icons-material/Campaign';
import PeopleIcon from '@mui/icons-material/People';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PublishIcon from '@mui/icons-material/Publish';
import InsightsIcon from '@mui/icons-material/Insights';
import ReceiptIcon from '@mui/icons-material/Receipt';
import GroupsIcon from '@mui/icons-material/Groups';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 240;

const menuItems = [
  { label: 'Campaigns', icon: <CampaignIcon />, path: '/create-campaign' },
  { label: 'Audiences', icon: <PeopleIcon />, path: '/create-audience' },
  { label: 'Spend Caps', icon: <MonetizationOnIcon />, path: '/spend-caps' },
  { label: 'Publish Campaign', icon: <PublishIcon />, path: '/publish-campaign' },
  { label: 'Campaign Insights', icon: <InsightsIcon />, path: '/campaign-insights' },
  { 
    label: 'Billing', 
    icon: <ReceiptIcon />, 
    path: '/billing-history',
    externalUrl: 'https://bitocircle.com/bitodollar-wallet'
  },
  { 
    label: 'Creator Collab Panel', 
    icon:  <GroupsIcon />, 
    path: '/billing-history',
    externalUrl: 'https://ad-center.bitocircle.com/creator-collabs'
  },
];

const Sidebar = ({ mobileOpen, onClose }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  
  const handleMenuItemClick = (item) => {
  if (item.externalUrl) {

    // If this is Creator Collab Panel → DO NOT append ?app=
    if (item.label === 'Creator Collab Panel') {
      const collabUrl = `${item.externalUrl}?uuid=${localStorage.getItem('uuid')}`;
      window.open(collabUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    // For all other external links → append ?app=
    const appval = localStorage.getItem('appData');
    const url = `${item.externalUrl}?app=${encodeURIComponent(appval)}`;

    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    navigate(item.path);
  }
};

  
  const drawerInner = (
    <>
      <Toolbar>
        <Typography variant="h6" sx={{ fontWeight: 'bold', ml: 1 }}>
          Ad Center
        </Typography>
      </Toolbar>
      <Divider />

      <List>
        {menuItems.map((item) => (
          <ListItemButton
            key={item.label}
            sx={{
              mx: 1,
              borderRadius: 1,
              mb: 0.5,
              '&:hover': {
                // backgroundColor: '#f5f5f5',
              },
              '&.Mui-selected': {
                backgroundColor: theme.palette.primary.main,
                color: 'white',
                '& .MuiListItemIcon-root': {
                  color: 'white',
                },
                '&:hover': {
                  backgroundColor: theme.palette.primary.main,
                },
              },
            }}
            selected={window.location.pathname === item.path}
            onClick={() => handleMenuItemClick(item)}
          >
            <ListItemIcon sx={{ color: '#757575', minWidth: 36 }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>

      <Box sx={{ flexGrow: 1 }} />

      <Box 
        sx={{ 
          px: 2, 
          py: 1.5,
          mb: 1,
          mx: 1,
          backgroundColor: '#f8f9fa',
          borderRadius: 1,
          border: '1px solid #e0e0e0',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <InfoOutlinedIcon sx={{ fontSize: 18, color: '#1976d2' }} />
          <Link
            href="https://bitocircle.com/business/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              color: '#1976d2',
              fontSize: '13px',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              '&:hover': {
                color: '#1565c0',
              },
            }}
          >
            Learn more
          </Link>
        </Box>
      </Box>
    </>
  );

  return (
    <>
      {isMdUp ? (
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          {drawerInner}
        </Drawer>
      ) : (
        <Drawer
          variant="temporary"
          open={Boolean(mobileOpen)}
          onClose={onClose}
          ModalProps={{ keepMounted: true }}
          sx={{
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
            },
          }}
        >
          {drawerInner}
        </Drawer>
      )}
    </>
  );
};

export default Sidebar;